import { catchError, of, switchMap, throwError } from 'rxjs';

import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { isHttpBackendResponse } from '../interfaces/generic.interface';
import { AuthStateService } from '../services/authstate.service';
import { NotificationsService } from '../services/notifications.service';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {

    const notifications = inject(NotificationsService);
    const auth = inject(AuthStateService);
    const actRoute = inject(ActivatedRoute)


    // Clone the request and add the authorization header
    let headers: any = {
        // "Content-Type": "application/json",
    }
    if (auth.isLogged) {
        headers["Authorization"] = `Bearer ${auth.token}`
    }

    let clonePayload: any = {
        setHeaders: headers,
        // withCredentials: true,
    }

    // if (typeof req.body === 'object' && req.body !== null) {
    //     const fd = new FormData();
    //     const processValue = (value: any): string => {
    //         if (value === null || value === undefined) {
    //             return '';
    //         }
    //         if (typeof value === 'object') {
    //             return JSON.stringify(value);
    //         }
    //         return String(value);
    //     };

    //     Object.entries(req.body).forEach(([key, value]) => {
    //         fd.append(key, processValue(value));
    //     });

    //     console.log(fd);

    //     clonePayload.body = fd;
    //     // Remove content-type to let browser set it with correct boundary
    //     delete headers['Content-Type'];
    // }

    const request = req.clone(clonePayload);
    const errorsPrefix = "errors."
    const errorsMap: { [key: number]: string } = {
        0: 'connectionError',
        400: 'invalidRequest',
        401: 'unauthorized',
        403: 'unauthorized',
        405: 'invalidOperation',
        404: 'notFound',
        429: 'tooManyRequests',
        500: 'internalError',
        502: 'badGateway',
        503: 'unavailable',
        504: 'requestTimeout',
    }

    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            let errorMessage = errorsMap[error.status] ?? 'generic';

            notifications.showNotification({
                severity: 'error',
                title: errorsPrefix + "errorWithCode",
                titleParams: { code: error.status },
                detail: errorsPrefix + errorMessage,
                source: request.headers.get('X-Request-Source') || errorsPrefix + 'generic'
            })

            if (error.status == 401) {
                auth.logout(true, actRoute.snapshot.url.join('/'))
            }
            return throwError(() => error);
        }),
        switchMap((resp: any) => {
            if (isHttpBackendResponse(resp.body)) {
                if (resp?.body?.notification) {
                    notifications.showBackendNotification(resp.body.notification)
                }

                if (resp?.body?.code && String(resp.body.code).substring(0, 1) != "2") {
                    if (!resp.body.notification) {
                        let errorMessage = errorsMap[resp.body.code] ?? 'generic';
                        notifications.showNotification({
                            severity: "error",
                            title: errorsPrefix + errorMessage,
                            source: request.headers.get('X-Request-Source') || errorsPrefix + 'generic'
                        })
                    }

                    if (resp.body.code == 401) {
                        auth.logout(true, actRoute.snapshot.url.join('/'))
                    }

                    return throwError(() => resp.body ?? resp)
                } else {
                    return of(resp)
                }
            } else {
                return of(resp)
            }
        }),
    );
};